export function alphanumericControl(event: KeyboardEvent) {
	const regexp: RegExp = /^[+àèìòùÀÈÌÒÙáéíóúýÁÉÍÓÚÝâêîôûÂÊÎÔÛãñõÃÑÕäëïöüÿÄËÏÖÜŸçÇßØøÅåÆæœa-zA-Z0-9]*$/;
	preventInputByRegExp(event, regexp);
}

export function alphanumericLot(event: KeyboardEvent) {
	const regexp: RegExp = /^[-a-zA-Z0-9]*$/;
	preventInputByRegExp(event, regexp);
}

export function disableReturn(event: KeyboardEvent) {
	if (event.key === 'Enter') {
		event.preventDefault();
	}
}

function preventInputByRegExp(event: KeyboardEvent, regexp: RegExp) {
	if (event.key === 'Backspace' || event.key === 'Tab' || event.key === 'Delete') {
		return event;
	} else if (!regexp.test(event.key)) {
		event.preventDefault();
	} else {
		return;
	}
}

function preventInputByRegExpWithSpace(event: KeyboardEvent, regexp: RegExp) {
	if (event.key === 'Backspace' || event.key === 'Tab' || event.key === 'Delete' || event.key === ' ') {
		return event;
	} else if (!regexp.test(event.key)) {
		event.preventDefault();
	} else {
		return;
	}
}

export function nameControl(event: KeyboardEvent) {
	const regexp: RegExp = /^[-'àèìòùÀÈÌÒÙáéíóúýÁÉÍÓÚÝâêîôûÂÊÎÔÛãñõÃÑÕäëïöüÿÄËÏÖÜŸçÇßØøÅåÆæœa-zA-Z0-9]*$/;
	preventInputByRegExpWithSpace(event, regexp);
}

export function nameControlParamDelegation(event: KeyboardEvent) {
	const regexp: RegExp = /^[-' a-zA-Z0-9]*$/;
	preventInputByRegExpWithSpace(event, regexp);
}

export function addressControl(event: KeyboardEvent) {
	const regexp: RegExp = /^[-',àèìòùÀÈÌÒÙáéíóúýÁÉÍÓÚÝâêîôûÂÊÎÔÛãñõÃÑÕäëïöüÿÄËÏÖÜŸçÇßØøÅåÆæœa-zA-Z0-9]*$/;
	preventInputByRegExpWithSpace(event, regexp);
}

export function nirControl(input: string): boolean {
	const regExp: RegExp = new RegExp('[0-9]{6}[0-9a-z]{1}[0-9]{6}', 'i');
	return regExp.test(input);
}

export function numericControl(event: KeyboardEvent) {
	const regexp: RegExp = /^[0-9]+$/;
	preventInputByRegExp(event, regexp);
}

export function finessRegExp(): RegExp {
	return /^([0-9][0-9A-Za-z][0-9]{7})|([*]{9})$/;
}

export function finessRegExpNoStars(): RegExp {
	return /^([0-9][0-9A-Za-z][0-9]{7})|([0-9][0-9A-Za-z][0-9]{12})$/;
}

export function numeroLotRegExp(): RegExp {
	return /^[-0-9A-Z]*$/;
}

export function nameParamDelegationRegExp(): RegExp {
	return /^[-' 0-9A-Z]*$/;
}

export function finessControl(event: KeyboardEvent) {
	const regexp: RegExp = /^[0-9A-Za-z*]$/;
	preventInputByRegExpWithSpace(event, regexp);
}

export function codeScolaireRegExp(): RegExp {
	return /^([0-9]{7}[A-Z])$/;
}

export function codeScolaireControl(event: KeyboardEvent) {
	const regexp: RegExp = /^[0-9A-Za-z]*$/;
	preventInputByRegExpWithSpace(event, regexp);
}
